import { Button as FBButton } from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import { useSelector } from "react-redux";
import { isButtonProcessing, getButtonProcessingClass } from "../../utils/common-utils";

const Button = (props) => {
  const { className, children, ...buttonProps } = props;
  const buttonProcessingState = useSelector((state) => state.button_processing);
  const isProcessing = isButtonProcessing(buttonProcessingState, props)
  const processingClass = getButtonProcessingClass(isProcessing);
  const buttonClass = `rounded-[6px] lg:h-10 h-[38px] ${
    className || ""
  } ${processingClass}`;
  return (
    <FBButton
      theme={tenkenTheme.button}
      className={buttonClass}
      isProcessing={isProcessing}
      {...buttonProps}
    >
      {children}
    </FBButton>
  );
};

export default Button;
